(() => {
  if (customElements.get('jj-halloween-purchase')) return;
  class HalloweenPurchase extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.quantity = this.querySelector('[name="quantity"]');
      this.idInput = this.querySelector('[data-purchase-id]');
      this.button = this.querySelector('[type="submit"]');
      this.querySelector('[data-kit-choice]')?.removeAttribute('hidden');
      const defaultKit = this.querySelector('[name="purchase_choice"][value="kit"]');
      if (defaultKit) defaultKit.checked = true;
      this.addEventListener('change', () => this.update());
      this.addEventListener('input', (event) => {
        if (event.target === this.quantity && this.quantity.validity.valid) this.update();
      });
      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-quantity-step]');
        if (!step) return;
        const amount = Number(step.dataset.quantityStep);
        this.quantity.value = Math.max(1, (Number(this.quantity.value) || 1) + amount);
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      this.form.addEventListener('submit', (event) => {
        if (!this.idInput.value || this.button.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      this.update();
    }
    update() {
      const choice = this.querySelector('[name="purchase_choice"]:checked');
      const isKit = choice.value === 'kit';
      const colors = this.querySelector('[data-kit-colors]');
      const color = this.querySelector('[name="bottle_color"]:checked');
      const qty = Math.max(1, Number(this.quantity.value) || 1);
      if (colors) {
        colors.hidden = !isKit;
        colors.disabled = !isKit;
        this.querySelector('[data-color-label]').textContent = color?.dataset.title || '';
      }
      this.querySelector('[data-quantity-step="-1"]').disabled = qty <= 1;
      const amount = Number(choice.dataset.price) * qty / 100;
      const price = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.dataset.currency,
        minimumFractionDigits: amount % 1 ? 2 : 0, maximumFractionDigits: 2
      }).format(amount);
      const available = choice.dataset.available === 'true' && (!isKit || (color && !color.disabled));
      this.idInput.value = available ? (isKit ? color.value : choice.dataset.variant) : '';
      this.button.disabled = !available;
      const unavailableLabel = this.dataset.unavailableLabel || 'Sold out';
      this.querySelector('[data-add-label]').textContent = available
        ? `Add ${qty > 1 ? qty + ' ' : ''}${isKit ? (qty > 1 ? 'kits' : 'kit') : 'Unroll'} · ${price}`
        : unavailableLabel;
      this.button.setAttribute('aria-label', available
        ? `Add ${qty} ${isKit ? `Unroll training kit${qty > 1 ? 's' : ''}, ${color.dataset.title}` : `Unroll tin${qty > 1 ? 's' : ''}`} to cart for ${price}`
        : unavailableLabel);
      this.querySelector('[data-order-note]').textContent = isKit
        ? `${qty === 1 ? 'One bottle + one Unroll tin' : `${qty} bottles + ${qty} Unroll tins`}. One-time purchase.`
        : `${qty === 1 ? 'One tin' : `${qty} tins`}. One-time purchase.`;
    }
  }
  customElements.define('jj-halloween-purchase', HalloweenPurchase);
})();
